import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-list",
  "use": "icon-list-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-list\"><defs><style></style></defs><path d=\"M838.4 320c0 12.8-12.8 25.6-25.6 25.6H211.2c-19.2 0-25.6-12.8-25.6-25.6v-57.6c0-12.8 12.8-25.6 25.6-25.6h601.6c12.8 0 25.6 12.8 25.6 25.6V320zm0 217.6c0 12.8-12.8 25.6-25.6 25.6H211.2c-19.2 6.4-25.6-6.4-25.6-25.6v-51.2c0-12.8 12.8-25.6 25.6-25.6h601.6c12.8 0 25.6 12.8 25.6 25.6v51.2zm0 224c0 12.8-12.8 25.6-25.6 25.6H211.2c-12.8 0-25.6-12.8-25.6-25.6V704c0-12.8 12.8-25.6 25.6-25.6h601.6c12.8 0 25.6 12.8 25.6 25.6v57.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/list.svg
// module id = vuHp
// module chunks = 9